import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import 'react-toastify/dist/ReactToastify.css';
import './fonts/vazir.ttf';
import './fonts/vazir.ttf';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import '../node_modules/bootstrap/dist/css/bootstrap.rtl.css';
import './assets/css/style.css'
import { AuthcontexProviderUser } from "./context/UserContext";
import { ManagerAuthcontexProvider } from "./context/AuthManager";
import { ManagerAuthConsultantProvider } from "./context/AuhConsultant";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ManagerAuthcontexProvider>
    <AuthcontexProviderUser>
    <ManagerAuthConsultantProvider>
        <App />
    </ManagerAuthConsultantProvider>
    </AuthcontexProviderUser>
    </ManagerAuthcontexProvider>

  </React.StrictMode>
);
